import React from 'react';
import { Route, Switch } from 'react-router-dom'
// var config = require('./js/config');

import TopBar from './js/components/TopBar/TopBar';
import Footer from './js/components/Footer/Footer';
import Login from './js/components/Login/Login';
import Logout from './js/components/Login/Logout';
import Register from './js/components/Registration/Registration';

import Home from './js/components/Home/Home';
import DashboardHome from './js/components/DashboardHome/DashboardHome';
import PrivateRoute from './js/components/PrivateRoute/PrivateRoute';
import AppointmentsContainer from './js/components/containers/AppointmentsContainer';
// import ProfileSettingsContainer from './js/components/containers/ProfileSettingsContainer';
import PasswordResetContainer from './js/components/containers/PasswordResetContainer';
import AccountActivation from './js/components/AccountActivation/AccountActivation';
import AdviceContainer from './js/components/containers/AdviceContainer';
import PassportContainer from './js/components/containers/PassportContainer';
import PageContainer from './js/components/containers/PageContainer';
import AdminContainer from './js/components/containers/AdminContainer';

import './App.css';



const NoMatch = ({ location }) => (
	<div className="container page-dashboard">
		<strong>Error!</strong> No route found matching:
		<code>{location.pathname}</code>	
	</div>
);


class App extends React.Component {

	render() {

		return (
			<div className="App">
				<TopBar />
				<Switch>
					<Route path='/login' component={Login} />
					<Route path='/register' component={Register} />
					<Route path='/logout' component={Logout} />
					<Route path='/password/reset/:token' component={PasswordResetContainer} />
					<Route path='/password/reset' component={PasswordResetContainer} />
					<Route exact path='/account/activation' component={AccountActivation} />
					<Route exact path='/account/activation/:id' component={AccountActivation} />
					<Route exact path='/advice' component={AdviceContainer} />
					<PrivateRoute exact path='/dashboard' component={DashboardHome} />
					<PrivateRoute exact path='/passport' component={PassportContainer} />
					<PrivateRoute exact path='/appointments' component={AppointmentsContainer} />
					{/*<PrivateRoute exact path='/profile/settings' component={ProfileSettingsContainer} />*/}
					<PrivateRoute exact path='/admin/stats' component={AdminContainer} />
					<Route exact path='/page/:slug' component={PageContainer} />
					<Route path='/' component={Home} />
			        <Route component={NoMatch} />
				</Switch>
				<Footer/>
			</div>

		);
	}
}


export default App;



// WEBPACK FOOTER //
// ./src/App.js